import { SVGProps } from 'react';

const CloudAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 12v4m0 4h.01M17 18h.5a4.5 4.5 0 1 0 0-9h-1.79A7 7 0 1 0 7 17.708"
    />
  </svg>
);
export default CloudAlert;
